<template>
  <div class="loader" :style="`--size: ${size};--num-dot: ${dots};--duration: ${duration};`">
    <div v-for="i in dots" :key="i" :style="`--index:${i - 1}`" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  size: { type: String, default: '120px' },
  dots: { type: Number, default: 10 },
  duration: { type: String, default: '1s' },
});
</script>

<style scoped lang="scss">
.loader {
  position: relative;
  font-size: var(--size);
  width: var(--size);
  height: var(--size);

  & > * {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    transform: rotate(calc((360deg / var(--num-dot) /* Number of child */) * var(--index)));

    &:before {
      position: absolute;
      content: '';
      top: 0.15em;
      left: 0.45em;
      width: 0.1em;
      height: 0.1em;
      transform: scale(0); /* First state is scale from 0 */
      border-radius: 50%;
      animation: scaleTo1 var(--duration) ease-in-out calc(var(--duration) / var(--num-dot) * var(--index)) infinite
        reverse;
    }
  }
}

@keyframes scaleTo1 {
  0% {
    transform: scale(0);
    background: var(--loader-neutral-0, var(--vvd-color-neutral-900));
  }
  100% {
    transform: scale(1);
    background: var(--loader-neutral-100, var(--vvd-color-neutral-50));
  }
}
</style>
